// Message code define


// Endpoint
export const RewardActivityPoint = {
  CREATE: 'admin/reward/create',
  UPDATE: 'admin/reward/update',
  DELETE: 'admin/reward/delete',
}